import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OutletModule } from '@spartacus/storefront';
import { PageComponentModule } from '../component/page-component.module';
import { PageSlotComponent } from './page-slot.component';

@NgModule({
  imports: [CommonModule, OutletModule, PageComponentModule],
  providers: [],
  declarations: [PageSlotComponent],
  exports: [PageSlotComponent],
})
export class PageSlotModule {}
